import { Grid, Typography } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import { imageTendenceSX } from '@/components/blocks/DpLibrary/DpCardTendence/style/image';
import {
	subtitleTendenceSX,
	titleTendenceSX,
} from '@/components/blocks/DpLibrary/DpCardTendence/style/typography';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { buttonContainerSX } from '@/components/blocks/DpLibrary/DpCardTendence/style/container';
import { Linkable } from '@/components/blocks/Linkable';
import React, { useContext } from 'react';
import { EventsContext } from '@/data/context/events';
import { useSettings } from '@/data/Settings';

export const DpCardTendence = ({
	title,
	subtitle,
	image,
	button,
	href,
	alt,
	loading,
	priority,
	index,
}: {
	title: string;
	subtitle: string;
	image: string;
	button: string;
	href?: string;
	alt?: string;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
	index?: number;
}) => {
	const { onBannerClick } = useContext(EventsContext);
	const { settings } = useSettings();

	const handleClick = () => {
		onBannerClick({
			gtm: {
				banner_name: alt ?? '',
				banner_url: href ?? '',
				banner_position: index ?? 0,
				settings,
			},
		});
	};

	return (
		<Grid item xs={12} md={6}>
			<Linkable href={href} onClick={handleClick}>
				<Img
					src={image}
					alt={alt ?? title}
					sx={imageTendenceSX}
					loading={loading}
					priority={priority}
				/>
				<Typography component="h3" sx={titleTendenceSX}>
					{title}
				</Typography>
			</Linkable>
			<Typography sx={{ ...subtitleTendenceSX, mb: '14px', mt: '7px' }}> {subtitle} </Typography>
			<Grid sx={buttonContainerSX}>
				<Linkable href={href} onClick={handleClick}>
					<DpButton text={button} />
				</Linkable>
			</Grid>
		</Grid>
	);
};
